import { CSSProperties } from '@linaria/atomic';
import { mdiAccountMultiple } from '@mdi/js';
import Icon from '@mdi/react';
import { IconProps } from '.';
import "./Viewers.linaria.module.css!=!./Viewers?./Viewers.linaria.module.css?css=H4sIAAAAAAAAA9NLLMmNTy+MN0pNKzQt0UPhVecmFqVn5ukm5ZeU5OdalSUWaejqoohpWtdyAQBs+9HwQgAAAA=="
const rootStyles = "atm_gq_2efq5t";

//
//
// Marc: There's a behavior here that I don't understand. If the word "style"
// is used instead of "styles", it adds "{ width: 0.1em, height: 0.1em }"
// automatically somehow. I have to look deeper into this but for now using
// the word "styles" as a workaround.
//
//

const IconViewers = (props: IconProps & {
  styles?: CSSProperties;
}) => {
  const {
    size = 0.8,
    styles,
    filled,
    title,
    color,
    ...other
  } = props;
  return <Icon path={mdiAccountMultiple} className={rootStyles} style={styles} title={title} color={color} size={size} {...other} />;
};
export default IconViewers;